import type { ReactNode } from "react";

/**
 * Minimal shell for consumer-facing public pages (/o/:code, /l/:code): no
 * Clerk, no AuthLayout nav, no PIN gate. Same tokens/safe-area padding as the
 * signed-in app so the page still looks like Mountain Mike's, not a bare
 * unstyled document.
 */
export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background px-safe pt-safe pb-safe">
      <div className="container-app mx-auto max-w-md py-8">{children}</div>
    </div>
  );
}
